import type React from 'react';

import { observer } from 'mobx-react';

import { Checkbox } from 'bz-core-controls';
import YesNoDialog from 'bz-core-controls/modal-new/confirmation/controls/yesno';

import DMARCDialogDescription from 'dmarc/controls/dialog-description';
import useEmailWarningDialog from 'dmarc/hooks/email-warning-dialog';
import { EmailWarningDialogStoreContext } from 'dmarc/stores/dialog-store';

export interface IProps {}

const EmailWarningDialog: React.FC<IProps> = observer(() => {
  const [dialogStore, onYes, onNo] = useEmailWarningDialog('/settings/communication/dns');
  const { checked, toggle } = dialogStore;

  return (
    <EmailWarningDialogStoreContext.Provider value={dialogStore}>
      <YesNoDialog
        open={dialogStore.isOpen}
        contents={
          <>
            <div className="mb-2">
              <DMARCDialogDescription />
            </div>
            <Checkbox label="Do not show again" value={checked} onChange={toggle} />
          </>
        }
        noLabel="Dismiss"
        title="Important Email Changes"
        yesLabel="Go To Settings"
        onNo={onNo}
        onYes={onYes}
      />
    </EmailWarningDialogStoreContext.Provider>
  );
});

EmailWarningDialog.displayName = 'EmailWarningDialog';

export default EmailWarningDialog;
